const getBandoSeverity = (status) => {
    switch (status) {
        case 'ACTIVE':
            return 'success';

        case 'SUBMIT':
            return 'success';

        case 'PUBLISH':
            return 'success';

        case 'APPROVED':
            return 'success';

        case 'VALID':
            return 'success';

        case 'READY_TO_PUBLISH':
            return 'info';

        case 'READY':
            return 'info';

        case 'NDG':
            return 'info';

        case 'APPOINTMENT':
            return 'info';

        case 'ADMISSIBLE':
            return 'info';

        case 'TECHNICAL_EVALUATION':
            return 'info';

        case 'IN_PROGRESS':
            return 'info';

        case 'AWAITING_TECHNICAL_EVALUATION':
            return 'warning';

        case 'DUE':
            return 'warning';

        case 'RESPONSE_RECEIVED':
            return 'warning';

        case 'SOCCORSO':
            return 'warning';

        case 'DRAFT':
            return 'warning';

        case 'AWAITING':
            return 'warning';

        case 'AWAIT':
            return 'warning';

        case 'OPEN':
            return 'warning';

        case 'ASSIGNED':
            return 'warning';

        case 'EVALUATION':
            return 'info';

        case 'EXPIRED':
            return 'closed';

        case 'CLOSE':
            return 'closed';

        case 'INACTIVE':
            return 'closed';

        case 'DOCUMENT_UPDATED':
            return 'warning';

        case 'REJECTED':
            return 'danger';

        case 'TECHNICAL_EVALUATION_REJECTED':
            return 'danger';

        case 'NOT_AVAILABLE':
            return 'closed';

        case 'RECEIVED':
            return 'info';

        case 'INTEGRATION_REQUESTED':
            return 'warning';

        case 'INTEGRATION_EXPIRED':
            return 'danger';

        default:
            return 'closed';
    }
};

export default getBandoSeverity;